module.exports = __webpack_public_path__ + "img/background.e885fc90.png";